import { motion } from "framer-motion";

export const Reveal = ({ children, y = 24, delay = 0, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.2, 0.7, 0.15, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`reveal-mask ${className}`}>
    <motion.span
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.05, delay, ease: [0.2, 0.7, 0.15, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const MaskedLineInView = ({ children, delay = 0, className = "" }) => (
  <span className={`reveal-mask ${className}`}>
    <motion.span
      initial={{ y: "110%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.05, delay, ease: [0.2, 0.7, 0.15, 1] }}
    >
      {children}
    </motion.span>
  </span>
);
